export const menuItems = [
    {
        id: 1,
        label: "Ana Sayfa",
        adminRequired:true,
        lmsRequired:true,
        userRequired:true,
        icon: "bx-home-circle",
        link: "/",
    },
    {
        id: 2,
        label: "Kullanıcılar",
        adminRequired:true,
        icon: "bx-user",
        link: "/users",
    },
    {
        id: 3,
        label: "Müşteriler",
        icon: "bx bxs-user-rectangle",
        adminRequired:true,
        userRequired:true,
        isUiElement: true,
        subItems: [
            {
                adminRequired:true,
                userRequired:true,
                label: 'Evraklar',
                link: "/contracts",
            },
            {
                adminRequired:true,
                userRequired:true,
                label: 'Müşteriler',
                link: "/customers",
            }]
    },
    {
        id: 4,
        label: "Plasiyerler",
        adminRequired:true,
        icon: "bxs-user-detail",
        isUiElement: true,
        subItems: [
            {
                adminRequired:true,
                label: 'Plasiyer Grupları',
                link: "/person-groups",
            },
            {
                adminRequired:true,
                label: 'Plasiyerler',
                link: '/persons',
             }]
    },
    {
        id: 6,
        label: "Ürünler",
        adminRequired:true,
        icon: "bx-cube",
        link: "/products",
    },
    {
        id: 7,
        label: "Raporlar",
        adminRequired:true,
        icon: "bxs-report",
        isUiElement: true,
        subItems: [
            {
                adminRequired:true,
                label: 'Satış Raporu',
                link: '/salesReports',
            },
            {
                adminRequired:true,
                label: 'Ödeme Raporu',
                link: '/paymentReports',
            },
            {
                adminRequired:true,
                label: 'Gecikmiş Ödemeler Raporu',
                link: '/delayedInstallmentReports',
            },
            {
                adminRequired:true,
                label: 'Banka Ödemeleri',
                link: '/bank-payments',
            }
            ]
    },
    {
        id: 9,
        label: "Sms",
        adminRequired:true,
        userRequired:true,
        icon: "bx-message-rounded-dots",
        isUiElement: true,
        subItems: [
            {
                adminRequired:true,
                userRequired:true,
                label: 'Sms Gönder',
                link: '/sms',
            },
            {
                adminRequired:true,
                label: 'Sms Şablonları',
                link: '/sms-templates',
            },
          /*  {
                adminRequired:true,
                label: 'Sms Logları',
                link: '/sms-logs',
            }*/
            ]
    },
    {
        id: 10,
        adminRequired:true,
        label: "Ayarlar",
        icon: "bx-cog",
        link: "/settings",
    },
    {
        id: 11,
        label: "LMS",
        adminRequired:true,
        lmsRequired:true,
        icon: "bx-book",
        isUiElement: true,
        subItems: [
            {
                adminRequired:true,
                lmsRequired:true,
                label: 'Kullanıcılar',
                link: '/customerUsers',
            },
            {
                adminRequired:true,
                lmsRequired:true,
                label: 'Siteler',
                link: '/sites',
            },
            {
                adminRequired:true,
                lmsRequired:true,
                label: 'Kurlar',
                link: '/levels',
            },
            {
                adminRequired:true,
                lmsRequired:true,
                label: 'Akademik Danışmanlar',
                link: '/advisors',
            },
            {
                adminRequired:true,
                lmsRequired:true,
                label: 'Eğitimler',
                link: '/educations',
            },

            {
                adminRequired:true,
                lmsRequired:true,
                label: 'Kurslar',
                link: '/courses',
            },
           {
               adminRequired:true,
               lmsRequired:true,
                label: 'Kampanyalar / İndirimler',
                link: '/Campaigns',
            }, {
                adminRequired:true,
                lmsRequired:true,
                label: 'Satışlar',
                link: '/sales',
            },
            ]
    },
];

